import React, { useState } from "react";
import { connect } from "react-redux";
import { billing as actions } from "actions";
import { createOptions } from "./Card_Element";
import { cancelStripeIntent } from "actions/stripe"; // Tarkista kansioiden määrä!
import {
  Elements,
  ElementsConsumer,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Message from "components/message";
import StripeElementWrapper from "components/styled/Stripe_Element_Wrapper";
import PoweredByStripeLogo from "components/elements/Powered_By_Stripe";
import Buttons from "components/elements/Buttons";
import Button from "components/elements/Button";
import Intl from "components/Intl";
import { returnStripePublishable } from "functions/hostname";

// Load Stripe once
const stripePromise = loadStripe(returnStripePublishable());

function UpdateCard({
  user,
  messages,
  locale,
  createSetupIntent,
  finalizePaymentMethod,
  history
}) {
  const [validation, setValidation] = useState({ error: true, message: "" });
  const [authFail, setAuthFail] = useState(false);
  const [cardInputsCompleted, setCardInputComplete] = useState({
    cardNumber: false,
    cardExpiry: false,
    cardCVC: false
  });

  const handleChange = ({ error, complete }, inputName) => {
    setCardInputComplete((prev) => ({
      ...prev,
      [inputName]: complete
    }));

    if (error) {
      setValidation({ error: true, message: error.message });
    } else if (!complete) {
      setValidation({ error: true, message: "" });
    } else {
      setValidation({ error: false, message: "" });
    }
  };
const handleCancel = async () => {
  try {
    // 1. Ilmoitetaan palvelimelle, että intent voidaan perua/siivota
    // Tämä kutsuu controllers/stripe.js:n cancelSetupIntent-metodia
     await dispatch(cancelStripeIntent());

    // 2. Ohjataan käyttäjä takaisin tai suljetaan näkymä
    // Jos olet modalissa tai haluat vain nollata tilan:
    setAuthFail(false);
    setValidation({ error: false, message: "" });
    
    // Jos haluat ohjata käyttäjän pois:
    history.push("/userhome/user_account/subscription");
  } catch (err) {
    console.error("Peruutus epäonnistui:", err);
    // Vaikka API-kutsu epäonnistuisi, on hyvä päästää käyttäjä pois näkymästä
    history.push("/userhome/user_account/subscription");
  }
};
  const handleUpdateCardButton = async () => {
    await createSetupIntent();
  };

  if (!user.stripeRequiresCardSetup) {
    return (
      <Buttons>
        <Button
          link
          to="/userhome"
          className="is-fullwidth is-success"
          group="stripe"
          name="startUsing"
        />
        <Button
          className="is-fullwidth"
          group="stripe"
          name="updateCard"
          onClick={handleUpdateCardButton}
        />
      </Buttons>
    );
  }

 return (
  <Elements stripe={stripePromise}>
    {authFail && (
      <Message default color="is-danger">
        <Intl 
           message
           path={"components.buttons.stripe.setupSubscription"} date={undefined} number={undefined} dateProps={undefined} numberProps={undefined} messageProps={undefined}        />
      </Message>
    )}

    <ElementsConsumer>
      {({ stripe, elements }) => {
        const submit = async (ev) => {
          ev.preventDefault();
          setAuthFail(false);
          setValidation({ error: false, message: "" });

          const cardElement = elements.getElement(CardNumberElement);

          if (!stripe || !elements || !cardElement) {
            console.error("Stripe.js or card element not ready");
            return;
          }

          try {
            // Suoritetaan vahvistus
            const { error, setupIntent } = await stripe.confirmCardSetup(
              user.stripeClientSecret,
              {
                payment_method: {
                  card: cardElement,
                  billing_details: { email: user.email }
                }
              }
            );

            let finalIntent = setupIntent;

            if (error) {
              // ✅ TARKISTUS: Jos intent on jo onnistunut (esim. HTTP 400 -virheen syy)
              if (error.setup_intent && error.setup_intent.status === "succeeded") {
                console.log("Intent already succeeded, proceeding to finalization.");
                finalIntent = error.setup_intent;
              } else {
                // Todellinen virhe
                console.error("Card setup failed:", error.message);
                setValidation({ error: true, message: error.message });
                setAuthFail(true);
                //if (cancelSetupIntent) await cancelSetupIntent();
                dispatch(cancelStripeIntent());
                return;
              }
            }

            // ✅ Viimeistely, jos tila on 'succeeded'
            if (finalIntent && finalIntent.status === "succeeded") {
              finalizePaymentMethod(finalIntent, () =>
                history.push("/userhome/user_account/subscription")
              );
            } else {
              // Jos tila on jotain muuta (esim. requires_action eikä sitä suoritettu)
              const statusMsg = finalIntent ? `Status: ${finalIntent.status}` : "Confirmation failed.";
              setValidation({ error: true, message: statusMsg });
              setAuthFail(true);
              //if (cancelSetupIntent) await cancelSetupIntent();
              dispatch(cancelStripeIntent());
            }
          } catch (err) {
            console.error("Unexpected error during card update:", err);
            setValidation({ error: true, message: "An unexpected error occurred." });
            setAuthFail(true);
            //if (cancelSetupIntent) await cancelSetupIntent();
            dispatch(cancelStripeIntent());
          }
        };

        const allInputsComplete = Object.values(cardInputsCompleted).every(
          (v) => v === true
        );

        return (
          <div className="checkout notification" style={{ padding: 8 }}>
            <div className="columns is-variable is-flex-desktop is-mobile is-multiline">
              <div className="column is-6-desktop is-12-mobile is-flex-desktop">
                <div className="box" style={{ width: "100%" }}>
                  <div className="level is-mobile">
                    <div className="level-left">
                      <p className="title is-5 has-text-dark">
                        {messages.labels.enterCardDetails[locale]}
                      </p>
                    </div>
                    <div className="level-right">
                      <PoweredByStripeLogo />
                    </div>
                  </div>

                  <label className="label is-small">
                    {messages.labels.cardNumber[locale]}
                    <StripeElementWrapper>
                      <CardNumberElement
                        options={createOptions()}
                        onChange={(e) => handleChange(e, "cardNumber")}
                      />
                    </StripeElementWrapper>
                  </label>

                  <label className="label is-small">
                    {messages.labels.cardExpiry[locale]}
                    <StripeElementWrapper>
                      <CardExpiryElement
                        options={createOptions()}
                        onChange={(e) => handleChange(e, "cardExpiry")}
                      />
                    </StripeElementWrapper>
                  </label>

                  <label className="label is-small">
                    {messages.labels.cardCVC[locale]}
                    <StripeElementWrapper>
                      <CardCvcElement
                        options={createOptions()}
                        onChange={(e) => handleChange(e, "cardCVC")}
                      />
                    </StripeElementWrapper>
                  </label>

                  {validation.error && (
                    <p className="is-danger help">{validation.message}</p>
                  )}
                </div>
              </div>

              <div className="column is-6-desktop is-12-mobile is-flex-desktop">
                <div className="box" style={{ width: "100%" }}>
                  <Buttons>
                    <Button
                      className="is-link is-fullwidth"
                      onClick={submit}
                      disabled={validation.error || !allInputsComplete}
                      group="stripe"
                      name="updateCard"
                    />
                    <Button
                      className="is-fullwidth"
                      onClick={handleCancel}
                      group="common"
                      name="cancel"
                    />
                  </Buttons>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </ElementsConsumer>
  </Elements>
);
}

const mapStateToProps = (state) => ({
  user: state.reducers.auth.user,
  messages: state.intl.messages.containers.subscription.stripe
});

export default connect(mapStateToProps, actions)(UpdateCard);
function dispatch(arg0) {
  throw new Error("Function not implemented.");
}

